import React from 'react';
import { Congress } from '../../congress';
import { SEO, Banner } from '../../common';
import { Layout } from '../../layout';

export default function CongressPage() {
  return (
    <Layout>
      <SEO title="VI Congreso de la SVRID 2023" />
      <Banner text={<>VI Congreso de la SVRID 2025</>} />
      <Congress />
    </Layout>
  );
}
